package uz.ferro.erp.feature.faq.ui

import kotlinx.coroutines.MainScope
import kotlinx.coroutines.launch
import mui.system.Box
import mui.system.sx
import react.FC
import react.create
import react.useEffectOnce
import react.useState
import uz.ferro.erp.Colors
import uz.ferro.erp.feature.faq.data.FaqManager
import uz.ferro.erp.feature.faq.model.FaqGroup
import uz.ferro.erp.pages.MAX_PAGE_AREA
import uz.ferro.erp.ui.AppTextBoldLarge
import uz.ferro.erp.ui.AppTextMedium
import uz.ferro.erp.ui.GenericPage
import uz.ferro.erp.util.styleInMobile
import web.cssom.Auto
import web.cssom.px

val FaqPage = FC {

    var faqGroups by useState(emptyList<FaqGroup>())

    fun loadData() {
        MainScope().launch {
            val data = FaqManager.getData()
            faqGroups = data
        }
    }

    useEffectOnce { loadData() }

    GenericPage {
        topFullWidthChildren = Box.create {
            sx {
                backgroundColor = Colors.accentColor
            }

            Box {
                sx {
                    maxWidth = MAX_PAGE_AREA
                    marginLeft = Auto.auto
                    marginRight = Auto.auto
                    padding = 16.px
                }

                AppTextMedium {
                    text = "Yordam"
                    color = Colors.white
                    sx {
                        fontSize = styleInMobile(22.px, 28.px)
                    }
                }
            }
        }

        Box {
            sx {
                padding = 15.px
            }

            faqGroups.forEach { group ->
                Box {
                    sx {
                        marginTop = 24.px
                    }
                    AppTextBoldLarge {
                        text = group.title
                    }

                    Box {
                        sx {
                            marginTop = 10.px
                        }
                        group.items.forEach {
                            FaqItemView {
                                item = it
                            }
                        }
                    }
                }
            }

            Box {
                sx {
                    height = 100.px
                }
            }
        }
    }
}



